"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAtByPlatform = void 0;
exports.checkAtByPlatform = {
    ELISA: {
        search: function (url) { return "".concat(url, "/intervention/liste"); },
        order: function (url, orderId) { return "".concat(url, "/tih/").concat(orderId, "/voir"); },
    },
    GTWEB: {
        search: function (url) { return url; },
        order: function (url, _orderId) { return url; },
    },
    SAPHYR: {
        search: function (url) { return url; },
        order: function (url, _orderId) { return url; },
    },
};
//# sourceMappingURL=robots.js.map